module.exports = __webpack_public_path__ + "img/证书@3x.91914030.png";